import { render, staticRenderFns } from "./education-teaching.vue?vue&type=template&id=e5af69bc&scoped=true&"
import script from "./education-teaching.vue?vue&type=script&lang=js&"
export * from "./education-teaching.vue?vue&type=script&lang=js&"
import style0 from "./education-teaching.vue?vue&type=style&index=0&id=e5af69bc&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5af69bc",
  null
  
)

export default component.exports